/**
 * Created by Rodrigo Quesada on 19/08/17.
 */
import {MixinConstructor} from '../mixins/mixins';
import {NavigationService} from '../../navigation/service/navigation.service';

export class ModalComponentBase {
    constructor(readonly _navigationService: NavigationService) {}
}

export const ModalComponent = <T extends MixinConstructor<ModalComponentBase>>(Base: T = ModalComponentBase as T) => {
    return class extends Base {

        constructor(...args: any[]) {
            super(...args);
            this._navigationService.disableKeyboardNavigation();
        }

        ngOnDestroy(): void { this._navigationService.enableKeyboardNavigation(); }
    };
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/modal/modal-component.class.ts